import { CATEGORYASTRO_FETCH_DATA_SUCCESS, CATEGORYASTRO_HAVE_ERROR, CATEGORYASTRO_ARE_LOADING } from '../actionType';
import HttpService from '../../utils/httpService';
import { Get } from '../../services/api.service'

export function categoryAstroAction(action, payload) {
    switch (action) {
        case CATEGORYASTRO_HAVE_ERROR:
            return {
                type: action,
                hasError: payload
            };

        case CATEGORYASTRO_ARE_LOADING:
            return {
                type: action,
                isLoading: payload
            };

        case CATEGORYASTRO_FETCH_DATA_SUCCESS:
            return {
                type: action,
                categoryAstro: payload,
            };

        default:
            return;
    }
}

export function categoryAstroFetchData() {
    return (dispatch) => {
        try {
            return new Promise((resolve, reject) => {
                dispatch(categoryAstroAction(CATEGORYASTRO_ARE_LOADING, true));
                Get(HttpService.categoryAstro).then((result) => {
                    dispatch(categoryAstroAction(CATEGORYASTRO_FETCH_DATA_SUCCESS, result.data));
                    resolve(result);
                }, (error) => {
                    reject(error);
                });
            });
        } catch (error) {
            dispatch(categoryAstroAction(CATEGORYASTRO_HAVE_ERROR, true));
        }
    }
}
